import { useMemo } from "react";

const RULES = [
  { id: "len", label: "8+ characters", test: (v) => v.length >= 8 },
  { id: "letter", label: "Letter", test: (v) => /[A-Za-z]/.test(v) },
  { id: "number", label: "Number", test: (v) => /\d/.test(v) },
  { id: "case", label: "Mixed case (bonus)", test: (v) => /[a-z]/.test(v) && /[A-Z]/.test(v) },
  { id: "special", label: "Special char (bonus)", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export default function PasswordStrength({ value }) {
  const { score, results, label, color, requiredOk } = useMemo(() => {
    const results = RULES.map((r) => ({ ...r, ok: r.test(value || "") }));
    const score = results.filter((r) => r.ok).length;
    const requiredOk = results.slice(0, 3).every((r) => r.ok);
    let label = "Too weak";
    let color = "bg-rose-400/70";
    if (score >= 5) { label = "Excellent"; color = "bg-emerald-400/80"; }
    else if (score >= 4) { label = "Strong"; color = "bg-emerald-400/60"; }
    else if (score >= 3) { label = "Good"; color = "bg-amber-400/70"; }
    else if (score >= 2) { label = "Weak"; color = "bg-amber-400/40"; }
    return { score, results, label, color, requiredOk };
  }, [value]);

  if (!value) return null;

  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1 mb-1.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded transition-colors ${i <= score ? color : "bg-white/8"}`}
          />
        ))}
      </div>
      <div className="flex items-center justify-between text-[10px] font-mono uppercase tracking-widest">
        <span className={requiredOk ? "text-emerald-300" : "text-white/40"} data-testid="password-strength-label">
          {label}
        </span>
        <span className="text-white/40">{score}/5</span>
      </div>
      <ul className="mt-2 grid grid-cols-2 gap-x-3 gap-y-0.5">
        {results.map((r) => (
          <li
            key={r.id}
            className={`text-[10px] flex items-center gap-1 ${
              r.ok ? "text-emerald-300/80" : "text-white/35"
            }`}
            data-testid={`pw-rule-${r.id}`}
          >
            <span className="font-mono">{r.ok ? "✓" : "·"}</span> {r.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
